import List from '../views/videos/list'

export default [
    {
        path: '/admin/domain/:domain_id/videos',
        name: 'videos',
        component: List,
    }
]
